import { render, staticRenderFns } from "./RestaurantAdd.vue?vue&type=template&id=90df9294"
import script from "./RestaurantAdd.vue?vue&type=script&lang=js"
export * from "./RestaurantAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports